import React from 'react'

const SponsorBanner = () => {
  return (
    <div className='text-center my-8'>
      <p className='text-text-secondary text-sm mb-2'>Patrocinado por:</p>
      <a
        href='https://nautilusvpn.com?ref=conversoriaecnae'
        target='_blank'
        rel='noopener noreferrer'
      >
        <img
          src='/resources/images/NautilusVPN_banner.png'
          alt='NautilusVPN Banner'
          className='mx-auto max-w-full h-auto'
          style={{ maxWidth: '728px' }}
        />
      </a>
    </div>
  )
}

export default SponsorBanner
